module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_ad-db51a366ca77f159858e0e9e545c0ca1.png";